export default function CircleDollarSign(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-28 -35)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={2} transform="translate(28 35)">
          <circle cx={10} cy={10} r={9.063} />
          <path d="M12.813 5.938H9.219a2.03 2.03 0 00-2.031 2.03h0A2.03 2.03 0 009.218 10h1.563c1.122 0 2.031.91 2.031 2.031h0a2.03 2.03 0 01-2.03 2.031H7.186M10 4.688v.625m0 9.375v.625" />
        </g>
      </g>
    </svg>
  );
}
